module.exports = __webpack_public_path__ + "static/img/rank_195.fe6e665.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_195.png
// module id = DlMc
// module chunks = 0